import {forwardRef} from 'react';
import type {ComponentProps} from 'react';
import classNames from 'classnames';

import {Input} from '@time-webkit/all/atoms/input';
import {SearchIcon} from '@time-webkit/all/icons/search';
import {CloseIcon} from '@time-webkit/all/icons';

import styles from './style.module.css';

export enum InputSearchSize {
    Large = 'large',
    Meduim = 'medium',
    Small = 'small',
}

type Props = {
    size: InputSearchSize;
    onClear?: () => void;
} & Omit<ComponentProps<typeof Input>, 'label' | 'multyline' | 'size'>;

export const InputSearch = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const {size, onClear, ...inputProps} = props;

    return (
        <Input
            {...inputProps}
            ref={ref}
            sizeClassName={classNames(styles[size])}
            iconLeft={
                <span className={styles.search_icon}>
                    <SearchIcon
                        width={size === InputSearchSize.Large ? 20 : 16}
                        height={size === InputSearchSize.Large ? 20 : 16}
                    />
                </span>
            }
            iconRight={
                props.value && onClear && (
                    <span className={styles.close_icon}>
                        <CloseIcon
                            width={size === InputSearchSize.Large ? 20 : 16}
                            height={size === InputSearchSize.Large ? 20 : 16}
                            data-testid='close'
                            onClick={onClear}
                        />
                    </span>
                )
            }
        />
    );
});
